import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import { Combo2Service } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";
import swal from "sweetalert2";
import { MatProgressSpinnerModule } from "@angular/material";

@Component({
  selector: "order-form-design-photo",
  templateUrl: "orderFormDesignPhoto.html",
})
export class orderFormDesignPhoto implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  mode: string;
  dataList = [];  
  IsWait: boolean = false;
  finyearCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  exceldata: any;
  headerData: any;
  orderList = [];
  filter = {
    order_no: "",
    fin_id: "",
  };
  columns = [];
  toggleCol = [];
  finyearList: any;

  constructor(
    private combo2Service: Combo2Service,
    private salesOrderServ: SalesOrderService,
    private spin: MatProgressSpinnerModule

  ) {}

  ngOnInit(): void {
    this.columns = [];
    this.finyearCombo();

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.filter.fin_id = res.data[0].fin_id;
    });
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  onEnterOrderNo(order_no) {
    if (order_no > 0) {
      this.IsWait = true;
      let params = {
        order_no: order_no,
        fin_id: this.filter.fin_id,
      };

      let that = this;
      that.loadingIndicator = true;
      that.salesOrderServ.getDesignPhotoOrderForm(params).then((res: any) => {
        that.IsWait = false;
        that.loadingIndicator = false;
        that.orderList = res.data;
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        if(that.orderList.length <=0){
          swal("This order wasn't a valid order form");
        }
      });
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/orderFormDesignPhoto/orderFormDesignPhoto.ts